module.exports = __webpack_public_path__ + "media/images/blue-key-8767d4bdff1c16d7f29cfe25c6aa62ac.png";